import React from "react"
import { connect } from "react-redux"
import { Col, Row, UncontrolledTooltip } from "reactstrap"
import { Area, AreaChart, Tooltip, XAxis } from "recharts"
import AdReports from "./AdReports"
import BookingTransactions from "./BookingTransactions"
import ProductsSubscriptionTransactions from "./ProductsSubscriptionTransactions"
import RecentExperiences from "./RecentExperiences"
import SmBasicTile from "./SmBasicTile"
import UsersChart from "./UsersChart"
import FormBuilderTransactions from "./formBuilderTransactions"

const WidgetRenderer = props => {
  const data = [
    {
      name: "Jul",
      sessions: 6,
      users: 10,
    },
    {
      name: "Aug",
      sessions: 7,
      users: 4,
    },
    {
      name: "Sep",
      sessions: 6,
      users: 8,
    },
    {
      name: "Oct",
      sessions: 9,
      users: 7,
    },
    {
      name: "Nov",
      sessions: 6,
      users: 5,
    },
    {
      name: "Dec",
      sessions: 11,
      users: 7,
    },
    {
      name: "Jan",
      sessions: 3,
      users: 9,
    },
  ]

  const roundNumber = value => {
    return Math.round(value / 1000)
  }

  const renderWidget = () => {
    switch (props?.name) {
      case "session_report":
        return (
          <SmBasicTile
            title="# of Sessions (month-to-date)"
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          >
            <Row>
              <Col xs={2} className="align-self-center">
                <div className="avatar-sm" id="allUsers">
                  <span className="avatar-title rounded-circle font-size-16">
                    {props?.userReports?.all_sessions < 999
                      ? props?.userReports?.all_sessions
                      : roundNumber(props?.userReports?.all_sessions) + "k"}
                  </span>
                </div>
                {props?.userReports?.all_sessions > 999 && (
                  <UncontrolledTooltip placement="top" target="allUsers">
                    {props?.userReports?.all_sessions}
                  </UncontrolledTooltip>
                )}
              </Col>
              <Col style={{ textAlign: "-webkit-right" }}>
                <AreaChart data={data} width={250} height={100}>
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#556ee6" stopOpacity={0.5} />
                      <stop offset="80%" stopColor="#556ee6" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="name" hide={true} />
                  <Area
                    type="monotone"
                    dataKey="sessions"
                    stroke="#556ee6"
                    fillOpacity={1}
                    fill="url(#colorUv)"
                    dot={{ strokeWidth: 0.3 }}
                  />
                  <Tooltip />
                </AreaChart>
              </Col>
            </Row>
          </SmBasicTile>
        )
      case "active_users":
        return (
          <SmBasicTile
            title="# of Active Users (month-to-date)"
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          >
            <Row>
              <Col xs={2} className="align-self-center">
                <div className="avatar-sm" id="activeUsers">
                  <span className="avatar-title rounded-circle font-size-16">
                    {props?.userReports?.active_users < 999
                      ? props?.userReports?.active_users
                      : roundNumber(props?.userReports?.active_users) + "k"}
                  </span>
                </div>
                {props?.userReports?.active_users > 999 && (
                  <UncontrolledTooltip placement="top" target="activeUsers">
                    {props?.userReports?.active_users}
                  </UncontrolledTooltip>
                )}
              </Col>
              <Col style={{ textAlign: "-webkit-right" }}>
                <AreaChart data={data} width={250} height={100}>
                  <defs>
                    <linearGradient id="colorUvv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#556ee6" stopOpacity={0.5} />
                      <stop offset="80%" stopColor="#556ee6" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="name" hide={true} />
                  <Area
                    type="monotone"
                    dataKey="users"
                    stroke="#556ee6"
                    fillOpacity={1}
                    fill="url(#colorUvv)"
                    dot={{ strokeWidth: 0.3 }}
                  />
                  <Tooltip />
                </AreaChart>
              </Col>
            </Row>
          </SmBasicTile>
        )
      case "device_report":
        return (
          <SmBasicTile
            title="Users by Device"
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          >
            <Row>
              <Col
                xs="6"
                className="d-flex flex-column justify-content-between"
              >
                <p># of sessions using iOS (month-to-date):</p>
                <div className="avatar-sm align-self-center" id="iosSessions">
                  <span className="avatar-title rounded-circle font-size-16">
                    {props?.userReports?.ios_sessions < 999
                      ? props?.userReports?.ios_sessions
                      : roundNumber(props?.userReports?.ios_sessions) + "k"}
                  </span>
                </div>
                {props?.userReports?.ios_sessions > 999 && (
                  <UncontrolledTooltip placement="top" target="iosSessions">
                    {props?.userReports?.ios_sessions}
                  </UncontrolledTooltip>
                )}
              </Col>
              <Col
                xs="6"
                className="d-flex flex-column justify-content-between"
              >
                <p># of sessions using Android (month-to-date):</p>
                <div
                  className="avatar-sm align-self-center"
                  id="androidSessions"
                >
                  <span className="avatar-title rounded-circle font-size-16">
                    {props?.userReports?.android_sessions < 999
                      ? props?.userReports?.android_sessions
                      : roundNumber(props?.userReports?.android_sessions) + "k"}
                  </span>
                </div>
                {props?.userReports?.android_sessions > 999 && (
                  <UncontrolledTooltip placement="top" target="androidSessions">
                    {props?.userReports?.android_sessions}
                  </UncontrolledTooltip>
                )}
              </Col>
            </Row>
          </SmBasicTile>
        )
      case "users_report":
        return (
          <UsersChart
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          />
        )
      case "exp_report":
        return (
          <RecentExperiences
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          />
        )
      case "ad_report":
        return (
          <AdReports
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          />
        )
      case "products_subscriprions_transactions":
        return (
          <ProductsSubscriptionTransactions
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          />
        )
      case "booking_transactions":
        return (
          <BookingTransactions
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          />
        )
      case "form_builder_transactions":
        return (
          <FormBuilderTransactions
            handleRemoveWidget={() => props?.handleRemoveWidget(props?.name)}
          />
        )
      default:
        return <></>
    }
  }

  return renderWidget()
}

const mapStateToProps = state => ({
  userReports: state.Analytics.userReports,
})

export default connect(mapStateToProps)(WidgetRenderer)
